import React from "react";
import SuperAdminRolesPermissions from "../superadmin/RolesPermissions";

/**
 * Institute/Admin Role Permissions (scoped by backend to current institute via JWT).
 * Reuses the Super Admin permission matrix UI for consistent UX.
 */
export default function AdminRolesPermissions() {
  return <SuperAdminRolesPermissions />;
}